// Isolated Vite build-time env access (`import.meta`). Kept in its own module so runtimeConfig
// stays unit-testable under Jest (ts-jest/CommonJS cannot parse `import.meta`). This is the
// LOCAL-DEV-ONLY fallback for runtime config; deployed builds use /api/runtime-config.
// (spec 20260701-runtime-spa-config-build-once-promote-many)
import type { RuntimeConfig } from "./runtimeConfig";

export function isViteDev(): boolean {
  return Boolean(import.meta.env.DEV);
}

export function viteFallbackConfig(): RuntimeConfig {
  const env = import.meta.env as Record<string, string | undefined>;
  return {
    functionAppUrl: (env.VITE_FUNCTION_APP_URL || "").trim(),
    conversationStreamApiBase: (env.VITE_CONVERSATION_STREAM_API_BASE || "").trim(),
    entraTenantId: (env.VITE_ENTRA_ID_TENANT_ID || "").trim(),
    entraClientId: (env.VITE_ENTRA_ID_CLIENT_ID || "").trim(),
    entraAuthority: (env.VITE_ENTRA_ID_AUTHORITY || "").trim(),
    stripePublishableKey: (env.VITE_STRIPE_PUBLISHABLE_KEY || "").trim(),
    recaptchaSiteKey: (env.VITE_RECAPTCHA_SITE_KEY || "").trim(),
    // Local dev defaults signup ON (set VITE_SIGNUP_ENABLED=false to test the gated state).
    signupEnabled: (env.VITE_SIGNUP_ENABLED || "true").trim().toLowerCase() !== "false",
  };
}
